'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var FlightAdjustmentValidationService = function FlightAdjustmentValidationService(overrideUtils) {
  function isValidValue(value) {
    return !_.isNil(value) && value !== '';
  }
  function validatePair(row, firstField, secondField) {
    return isValidValue(row[firstField]) && !isValidValue(row[secondField]);
  }
  function validPercentageValue(value) {
    return isValidValue(value) && value >= 0 && value <= 100;
  }
  function validateAllocation(row) {
    if (validatePair(row, 'userMaxAllocation', 'userMinAllocation')) {
      toastr.error('Min Usr Allocation is mandatory when Max Usr Allocation is entered');
      return false;
    }
    if (validatePair(row, 'userMinAllocation', 'userMaxAllocation')) {
      toastr.error('Max Usr Allocation is mandatory when Min Usr Allocation is entered');
      return false;
    }
    if (row.userAllocationType === 'P' && (!validPercentageValue(row.userMinAllocation) || !validPercentageValue(row.userMaxAllocation))) {
      toastr.error('Percentage Usr Allocation values must be between 0 and 100.');
      return false;
    }
    return true;
  }
  function validateRtpOverride(row) {
    if (!overrideUtils.isValidStartRtpOverride(row)) {
      toastr.error('Demand adjustment cannot be empty if startRtp is set');
      return false;
    }
    return true;
  }
  function validateRows(modifiedRows) {
    var rowsValid = true;
    _.forEach(modifiedRows, function (row) {
      rowsValid = rowsValid && validateAllocation(row);
      rowsValid = rowsValid && validateRtpOverride(row);
    });
    return rowsValid;
  }
  return {
    validateRows: validateRows
  };
};
FlightAdjustmentValidationService.$inject = ['OverridesUtilsService'];
module.exports = FlightAdjustmentValidationService;